import React, { FC, PropsWithChildren } from "react";
import { Grid, GridProps } from "theme-ui";
import PropTypes from "prop-types";

const propTypes = {
  odd: PropTypes.bool,
};

const defaultProps = {
  odd: false,
};

type GridOddEvenType = PropTypes.InferProps<typeof propTypes> &
  PropsWithChildren &
  GridProps;

export const GridOddEven: FC<GridOddEvenType> = ({
  odd,
  children,
  ...props
}: GridOddEvenType) => (
  <Grid variant={odd ? "odd" : "even"} {...props}>
    {children}
  </Grid>
);

GridOddEven.propTypes = propTypes;
GridOddEven.defaultProps = defaultProps;
